// extracted by mini-css-extract-plugin
export var loadingSpinner = "_y-0";
export var spinnerContainer = "_y-1";